import { Component, inject } from '@angular/core';
import { GeneticMaterialCrossingService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GeneticMaterialCrossingCreateDto,
  GeneticMaterialCrossingDto,
  GeneticMaterialCrossingExcelDownloadDto,
  GeneticMaterialCrossingUpdateDto,
} from '../proxy/general/dtos/genetic-material-crossing';
import { GENETICMATERIALCROSSING_CONFIG, GENETICMATERIALCROSSING_FIELDS } from './genetic-material-crossing.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genetic-material-crossing',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GeneticMaterialCrossingService, ConfirmationService],
  templateUrl: './genetic-material-crossing.html',
  styleUrl: './genetic-material-crossing.scss',
})
export class GeneticMaterialCrossing extends BaseCrudComponent<
  GeneticMaterialCrossingDto,
  GeneticMaterialCrossingCreateDto,
  GeneticMaterialCrossingUpdateDto,
  GeneticMaterialCrossingExcelDownloadDto
> {
  service = inject(GeneticMaterialCrossingService);
  config = GENETICMATERIALCROSSING_CONFIG;
  fields = GENETICMATERIALCROSSING_FIELDS;

  protected prepareUpdateDto(data: any, selected: GeneticMaterialCrossingDto): GeneticMaterialCrossingUpdateDto {
    return {
      name: data.name,
      geneticMaterialCrossingTypeId: data.geneticMaterialCrossingTypeId,
      creationDate: data.creationDate,
      maleGeneticMaterialId: data.maleGeneticMaterialId,
      femaleGeneticMaterialId: data.femaleGeneticMaterialId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GeneticMaterialCrossing';
  }
}
